// check if a string starts with a letter
const startsWithLetter = (str: string) => /^[A-Za-z]/.test(str)

// Sort function
export const sortAlphanumerically = (entities: any) => {
  entities.sort((a: any, b: any) => {
    const titleA = a.title
    const titleB = b.title

    const aStartsWithLetter = startsWithLetter(titleA)
    const bStartsWithLetter = startsWithLetter(titleB)

    // If one starts with a letter and the other starts with a number
    if (aStartsWithLetter && !bStartsWithLetter) return -1 // Letters come first
    if (!aStartsWithLetter && bStartsWithLetter) return 1 // Numbers come after

    // If both start with letters or both start with numbers, sort alphabetically
    return titleA.localeCompare(titleB, undefined, { numeric: true })
  })

  return entities
}

export const sanitiseObject = (object: { [key: string]: any }, allowedKeys: string[]) => {
  const sanitisedObject = {}

  allowedKeys.forEach((key) => {
    // @ts-expect-error TS7053
    if (object[key]) sanitisedObject[key] = object[key]
  })

  return sanitisedObject
}

export default sanitiseObject

export const stringHasContent = (str: string | undefined) => {
  if (!str || typeof str !== 'string') return false
  if (str.trim().length > 0) return true
  return false
}
